"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shortid = _interopRequireDefault(require("shortid"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _LoadingRows = _interopRequireDefault(require("./LoadingRows.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cx = _bind["default"].bind(_LoadingRows["default"]);

var LoadingRows = function LoadingRows(_ref) {
  var numberOfRows = _ref.numberOfRows,
      numberOfColumns = _ref.numberOfColumns;
  var rows = [];
  var rowColumns = [];

  for (var j = 0; j < numberOfColumns; j += 1) {
    rowColumns.push( /*#__PURE__*/_react["default"].createElement("td", {
      className: cx('loading-column', {
        'first-column': j === 0
      }),
      key: _shortid["default"].generate()
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: cx('loading__container')
    })));
  }

  for (var i = 0; i < numberOfRows; i += 1) {
    rows.push( /*#__PURE__*/_react["default"].createElement("tr", {
      className: cx('loading-row'),
      key: _shortid["default"].generate()
    }, rowColumns));
  }

  return rows;
};

LoadingRows.propTypes = {
  numberOfColumns: _propTypes["default"].number.isRequired,
  numberOfRows: _propTypes["default"].number.isRequired
};
var _default = LoadingRows;
exports["default"] = _default;